import React from 'react';
import { Box, Stack } from '@mui/material';

import Background from 'components/Questionnaire/common/Background';
import FormIO from './FormIO';

const Form = ({
  form,
  onSubmit,
  onCancel,
  defaultValues,
  onSave,
  onNext,
  handleTaskEntryChange,
  page,
  readOnly,
}) => {
  return (
    <Stack
      alignItems='center' sx={{ position: 'relative' }}>
      <Background />
      <Box
        p='90px 20px'>
        <FormIO
          form={form}
          onSubmit={onSubmit}
          onSave={onSave}
          onNext={onNext}
          handleTaskEntryChange={handleTaskEntryChange}
          page={page}
          onCancel={onCancel}
          defaultValues={defaultValues}
          readOnly={readOnly}
        />
      </Box>
    </Stack>
  );
};

export default Form;
